<script setup lang="ts">
/** The step panel body (scrolls; reset to the top per step) and the docked action row. */
</script>

<template>
  <div id="panelBody" class="panel-body" tabindex="-1">
    <div class="panel-inner">
      <slot />
    </div>
  </div>
  <div id="dock" class="dock">
    <div class="dock-inner">
      <slot name="dock" />
    </div>
  </div>
</template>
